"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.TeamTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    /** Owning organization's hauler id. */
    organizationID: typebox_1.Type.String({ format: 'uuid' }),
    /** Stable SCREAMING_SNAKE identifier, e.g. 'BILLING'. */
    code: typebox_1.Type.String(),
    /** Display name, e.g. 'Billing'. */
    label: typebox_1.Type.String(),
    /** Optional Slack incoming-webhook URL for routing team notifications (production URL). */
    slackChannelUrl: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=team-transport.js.map